module.exports = __webpack_public_path__ + "static/media/llp-banner-desktop.aebefd4e.webp";